import React from "react";
import PropTypes from "prop-types";
import { isEmpty } from "utils/data/validators";
// import Linkify from "linkify-react";
import cx from "classnames";
import player from "utils/player";
import { EVENT_KEY, EventEmitter } from "utils/eventManager";

const propTypes = {
  active: PropTypes.bool,
  url: PropTypes.string,
  timestamp: PropTypes.number,
};

const defaultProps = {
  active: false,
  url: "",
  timestamp: 0,
};

const Url = ({ active, url, timestamp }) => {
  if (isEmpty(url)) return null;

  const handleOnClick = () => {
    EventEmitter.dispatch(EVENT_KEY.RESTART_VIDEO, { url, timestamp });
    player.primary.currentTime(timestamp);
  };

  return (
    <div
      onClick={handleOnClick}
      className={cx("linkified", { "link-active": active })}
    >
      {url}
    </div>
  );

  // const options = {
  //   className: cx("linkified", { inactive: !active }),
  //   target: "_blank",
  // };

  // return (
  //   <Linkify options={options}>
  //     {url}
  //   </Linkify>
  // );
};

Url.propTypes = propTypes;
Url.defaultProps = defaultProps;

export default Url;
